import axios from 'axios';

const apiClient = axios.create({
    timeout: 15000,
});

apiClient.interceptors.request.use((config) => {
    try {
        const userProfileString = localStorage.getItem('userProfile');
        if (!userProfileString) {
            return config;
        }

        const userProfile = JSON.parse(userProfileString);
        const jwtToken = userProfile?.token?.token;

        if (jwtToken) {
            config.headers.Authorization = `Bearer ${jwtToken}`;
        }
    } catch (error) {
        console.error('Error reading auth token:', error.message);
    }

    return config;
});

export const getAuthHeaders = (extraHeaders = {}) => {
    const headers = { ...extraHeaders };

    try {
        const userProfileString = localStorage.getItem('userProfile');
        if (userProfileString) {
            const userProfile = JSON.parse(userProfileString);
            const jwtToken = userProfile?.token?.token;
            if (jwtToken) {
                headers.Authorization = `Bearer ${jwtToken}`;
            }
        }
    } catch (error) {
        console.error('Error reading auth token:', error.message);
    }

    return headers;
};

export const asTableRows = (data) => (Array.isArray(data) ? data : []);

export default apiClient;
